import request from '@/utils/request'

export function getPublic (deviceCode)  {
  return request({
    url: `/api/test/getPublic?deviceCode=${deviceCode}`,
    method: 'GET',
  });
};

// 推送机构测评结果

export function orgtest(data) {
  return request({
    url: '/api/orgtest',
    method: 'post',
    data: data
  })
}
// 获取测评历史记录
    // deviceCode: string;
    // testId: string;
export function history(query) {
  return request({
    url: '/api/test/history',
    method: 'get',
    params: query
  })
}
// 获取测评报告
    // testCode: string;
export function testReport(query) {
  return request({
    url: '/api/test/report',
    method: 'get',
    params: query
  })
}


